import {Component, OnInit, OnDestroy} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {Router} from '@angular/router';
import {Subscription} from 'rxjs/Subscription';
import {VehicleService} from 'services/calculator-items/vehicle.service';
import {EmissionService} from 'services/emission.service';
import {FooterNavbarService} from 'services/connectors/footer-navbar.service';
import {UnsavedCar} from 'models/unsavedCar';
import {SpinnerService} from 'services/spinner.service';

@Component({
    selector: 'tpc-options',
    templateUrl: './options.component.html',
    styleUrls: ['./options.component.css']
})
export class OptionsComponent implements OnInit, OnDestroy {
    private nextSub: Subscription;
    private unsavedCar: UnsavedCar;
    private isFormSubmitted = false;

    public optionForm: FormGroup;
    public carSubModelList = [];

    constructor(private emissionService: EmissionService,
                private vehicleService: VehicleService,
                private footerService: FooterNavbarService,
                private router: Router,
                private fb: FormBuilder,
                private spinner: SpinnerService
    ) {
        this.nextSub = footerService.next$.subscribe(() => {
            this.isFormSubmitted = true;
            if (this.optionForm.status === 'VALID') {
                this.next();
            }
        });
        this.createForm();
    }

    ngOnInit() {
        let unsavedCar = this.vehicleService.getLastUnsavedCar();

        if (!unsavedCar) {
            this.router.navigate(['/']);
        } else {
            this.unsavedCar = unsavedCar;
            this.getSubModelList();
        }
    }

    private createForm() {
        this.optionForm = this.fb.group({
            carSubModel: ['', Validators.required ]
        });
    }

    private getSubModelList() {
        let car = this.unsavedCar;
        this.spinner.show();
        this.vehicleService.getAllSubModels(car.year, car.make, car.model).subscribe(
            subModels => {
                this.carSubModelList = subModels;
                this.spinner.hide();
            }
        );
    }

    private next() {
        let subModel = this.optionForm.get('carSubModel').value;
        let params = {
            CARTYPE: 'car',
            FUELTYPE: subModel.fuel,
            MILE: this.unsavedCar.mileage,
            MPG: subModel.mpg,
            VEHICLETYPE: 'car',
            YEAR: this.unsavedCar.year,
        };

        this.spinner.show();
        this.emissionService.getEmissionValue(params).subscribe(
            response => {
                let input = response.body[0].input[0];
                this.vehicleService.addToVehicleList({
                    title: this.getTitleForVehicleList(),
                    emission: input.emmission,
                    emissionTrees: input.emissionTrees,
                    DollarAmt: input.DollarAmt,
                    DollarAmtMonthly: input.DollarAmtMonthly
                });

                this.router.navigate(['/individual/vehicle/list']);
                this.spinner.hide();
            }
        );
    }

    private getTitleForVehicleList() {
        let car = this.unsavedCar;
        return `${car.year} ${car.make} ${car.model}, ${car.mileage.toLocaleString()} mi/yr`;
    }

    getSubModelName(model) {
        return `${model.trans}, ${model.cyl}, ${model.drive}, ${model.displ}`;
    }

    checkError(param) {
        return this.optionForm.get(param).status === 'INVALID' && (this.isFormSubmitted || this.optionForm.get(param).touched);
    }

    ngOnDestroy () {
        if (this.nextSub) {
            this.nextSub.unsubscribe();
        }
    }

}



// WEBPACK FOOTER //
// ./src/app/components/calculator/calculator-item/shared/main/vehicle/car/options/options.component.ts